import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../../controllers/academics/academicsStages";
import { list as academicsList } from "../../../controllers/academics/academics";
import imageCompression from "browser-image-compression";

import { fetchIpAddress } from "../../../controllers/API";

import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";
import ReactQuill from 'react-quill';

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [academicsPages, setAcademicsPages] = useState([]);
  const [CONTENT, setContent] = useState('');

  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
  const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, image: "Please upload a valid image file." }));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, image: "Image must be smaller than 5MB." }));
      return;
    }

    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setImage([newFile]);
      setError((prev) => ({ ...prev, image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file) => {
    setImage([]); // Clear the image
    // message.success("Image removed successfully!");
  };
  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        title,
        grade,
        content,
        page,
        sortno,
        link
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("edit_id", _id);
      }
      form.append("grade", grade);
      form.append("title", title);
      form.append("content", CONTENT);
      form.append("page", page);
      form.append("sortno", sortno);
      form.append("link", link);
      if (image.length > 0) {
        form.append("image", image[0]?.originFileObj);
      }
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: "academics/stages/addeditdata",
          postData: form,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added Successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/academic/stages");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("grade").trim() || form.get("grade").trim() === "undefined" || form.get("grade").trim() === null) {
      setError((preError) => ({
        ...preError,
        grade: "Grade is required",
      }));
      return false;
    }
    if (!form.get("title").trim() || form.get("title").trim() === "undefined" || form.get("title").trim() === null) {
      setError((preError) => ({
        ...preError,
        title: "Title is required",
      }));
      return false;
    }
    if (!form.get("content").trim() || form.get("content").trim() === "undefined" || form.get("content").trim() === null) {
      setError((preError) => ({
        ...preError,
        content: "Content is required",
      }));
      return false;
    }
    if (!form.get("page") || form.get("page") === "undefined" || form.get("page") === null) {
      setError((preError) => ({
        ...preError,
        page: "Page is required",
      }));
      return false;
    }
    if (!ADDEDITDATA?._id && (!form.get("image") || form.get("image") == null)) {
      setError((preError) => ({
        ...preError,
        image: "Image is required",
      }));
      return false;
    }
    if (!form.get("sortno") || form.get("sortno") === "undefined" || form.get("sortno") === null) {
      setError((preError) => ({
        ...preError,
        sortno: "Sort no. is required",
      }));
      return false;
    }
    return true;
  };

  /*********************************************************
   *  This function is used for get all product categories
   *********************************************************/
  const getAcademicsPages = async () => {
    try {
      const bannerWhere = {
        type: "",
        condition: {
          status: "A"
        }
      };
      const acadPages = await academicsList(bannerWhere);
      if (acadPages.result && acadPages?.result.length > 0) {
        setAcademicsPages(acadPages.result);
      } else {
        setAcademicsPages([]);
      }
    } catch (error) {
      console.log('no pages found');
      setAcademicsPages([]);
    }
  };

  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    getAcademicsPages();
    setContent(ADDEDITDATA?.content);
    document.title = `KC High Super Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } Academics Stages`;
  }, []);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} Stages
            </h5>
          </div>
          <Link to="/academic/stages">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row">
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="grade"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Grade :{" "}
                    </label>
                    <input
                      title="Enter grade"
                      placeholder="Enter grade"
                      type="text"
                      name="grade"
                      className="form-control store_input_field"
                      id="grade"
                      value={ADDEDITDATA?.grade}
                      onChange={handleChange}
                    />
                    {error.grade ? (
                      <p style={{ color: "red" }}>
                        {error.grade}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="subtitle"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Title :{" "}
                    </label>
                    <input
                      title="Enter title"
                      placeholder="Enter title"
                      type="text"
                      name="title"
                      className="form-control store_input_field"
                      id="title"
                      value={ADDEDITDATA?.title}
                      onChange={handleChange}
                    />
                    {error.title ? (
                      <p style={{ color: "red" }}>
                        {error.title}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                    <label className="categories_open_popup_label_name all_lebel_margin_top_main_div">Content </label>
                  </div>
                  <div className="term_and_condation_react_quilllll">
                    <ReactQuill
                      theme="snow"
                      value={CONTENT || ''}
                      onChange={setContent}
                    />
                  </div>
                  {error.content ? (<p style={{color:"red"}}>{error?.content}</p>) : ("")}
                  <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 ">
                    <label for="type" className="categories_open_popup_label_name all_lebel_margin_top_main_div" > <span style={{ color: "red" }}>*</span> Page</label>
                    <select className="form-control categories_select_tg_enter_product" name='page' id='page' onChange={handleChange}>
                      <option value="">Select page</option>
                      {academicsPages && academicsPages.map(pages => (
                        <option
                          key={pages?.slug}
                          value={pages?.slug}
                          selected={ADDEDITDATA?.page === pages?.slug ? true : false}
                        >
                          {pages?.name}
                        </option>
                      ))}
                    </select>
                    {error.page ? (<p style={{ color: "red" }}> {error.page} </p>) : ("")}
                  </div>
                  <div className="form-group col-lg-4 col-md-4 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="sortno"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Sort no. :{" "}
                    </label>
                    <input
                      title="Enter Sort no."
                      placeholder="Enter Sort no."
                      type="number"
                      name="sortno"
                      className="form-control store_input_field"
                      id="sortno"
                      max={100}
                      value={ADDEDITDATA?.sortno}
                      onChange={handleChange}
                    />
                    {error.sortno ? (
                      <p style={{ color: "red" }}>
                        {error.sortno}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="link"
                      className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                    >
                      <span style={{ color: "red" }}>*</span>Link :{" "}
                    </label>
                    <input
                      title="Enter link"
                      placeholder="Enter link"
                      type="text"
                      name="link"
                      className="form-control store_input_field"
                      id="link"
                      value={ADDEDITDATA?.link}
                      onChange={handleChange}
                    />
                    {error.link ? (
                      <p style={{ color: "red" }}>
                        {error.link}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Images
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="1"
                    listType="picture-card"
                    onChange={handleImageChange}
                    fileList={image}
                    beforeUpload={() => false} // Prevent automatic upload
                    onRemove={handleRemove} 
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG) of dimension 400x490.
                  </p>
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
